var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOmniShape1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 693,
    height: 628,
    viewBox: "0 0 693 628",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.7,
    clipPath: "url(#clip0_111_29)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M535.728 501.475C619.675 501.628 687.852 433.7 688.005 349.753C688.158 265.806 620.229 197.629 536.282 197.476C452.335 197.323 384.158 265.251 384.005 349.199C383.852 433.146 451.781 501.322 535.728 501.475Z",
    stroke: "#3E5C53",
    strokeWidth: 7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9433 108.602C85.9382 108.655 109.486 85.1926 109.539 56.1977C109.592 27.2028 86.1296 3.65494 57.1347 3.60209C28.1398 3.54923 4.59192 27.0114 4.53906 56.0063C4.4862 85.0012 27.9484 108.549 56.9433 108.602Z",
    stroke: "#3E5C53",
    strokeWidth: 7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M249.006 622.953C278.001 623.006 301.549 599.544 301.602 570.549C301.654 541.554 278.192 518.006 249.197 517.953C220.203 517.9 196.655 541.362 196.602 570.357C196.549 599.352 220.011 622.9 249.006 622.953Z",
    stroke: "#3E5C53",
    strokeWidth: 7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.263 92.0647L387.962 257.564",
    stroke: "#3E5C53",
    strokeWidth: 5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M315.685 528.568L401.802 464.725",
    stroke: "#3E5C53",
    strokeWidth: 5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_111_29"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 691,
    height: 626,
    fill: "white",
    transform: "translate(1.14111) rotate(0.10445)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmniShape1);
export default __webpack_public_path__ + "static/media/omni_shape_1.5c820174fc186d3ecb7482388efbb605.svg";
export { ForwardRef as ReactComponent };